export default __webpack_public_path__ + "static/media/demo-1.8e602b4e.png";